import { Link } from 'react-router-dom';
import type { Article } from '@/types/content';

const rankTone = (index: number) =>
  index === 0
    ? 'bg-accent-500 text-background-50'
    : index === 1
      ? 'bg-secondary-400 text-secondary-950'
      : index === 2
        ? 'bg-primary-500 text-background-50'
        : 'bg-background-200 text-foreground-700';

const HotRanking = ({ items }: { items: Article[] }) => (
  <section aria-labelledby="hot-ranking-title" className="bg-background-100 border border-background-200 rounded-lg p-4 md:p-5">
    <div className="flex items-center justify-between mb-4">
      <h3 id="hot-ranking-title" className="font-heading text-lg font-bold text-foreground-950 flex items-center gap-2">
        <i className="ri-fire-line text-accent-500" />
        今日吃瓜热榜
      </h3>
      <span className="text-[11px] text-foreground-500">每 10 分钟更新</span>
    </div>

    <ol className="space-y-2">
      {items.map((item, index) => (
        <li key={item.id}>
          <Link
            to={`/article/${item.id}`}
            className="flex items-start gap-3 rounded-md p-2 transition-colors hover:bg-background-50"
          >
            <span
              className={`shrink-0 w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold ${rankTone(index)}`}
            >
              {index + 1}
            </span>
            <span className="flex-1 min-w-0">
              <span className="block text-sm leading-5 text-foreground-900 line-clamp-2">{item.title}</span>
              <span className="mt-1 flex items-center gap-3 text-[11px] text-foreground-500">
                <span className="flex items-center gap-1 text-accent-600">
                  <i className="ri-fire-line" />
                  {item.heat}
                </span>
                <span>{item.category}</span>
              </span>
            </span>
          </Link>
        </li>
      ))}
    </ol>
  </section>
);

export default HotRanking;